import type { CampaignScope } from '@ms/yammer-data/dist/state/types';
import type { CreateCampaignClickedEntrypoint } from '@ms/yammer-data/dist/telemetry/report/protobuf/campaigns';
import type { RenderCallback } from '@ms/yammer-web-core-ui/dist/util/useRenderToggleableContent';
import { useRenderToggleableContent } from '@ms/yammer-web-core-ui/dist/util/useRenderToggleableContent';
import React, { useCallback } from 'react';

import LoadableCampaignCreateModal from '../LoadableCampaignCreateModal';

type UseCampaignCreateModal = (
  entryPoint: CreateCampaignClickedEntrypoint,
  scope?: CampaignScope
) => ReturnType<typeof useRenderToggleableContent>;
export const useCampaignCreateModal: UseCampaignCreateModal = (entryPoint, scope) => {
  const renderCallback: RenderCallback = useCallback(
    ({ hideContent }) => <LoadableCampaignCreateModal onDismiss={hideContent} scope={scope} entrypoint={entryPoint} />,
    [entryPoint, scope]
  );

  return useRenderToggleableContent(renderCallback);
};
